import config from '../../config/config';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  [key: string]: any;
}

export default {
  /**
   * Create custom dashboard
   * @param {any} data data
   * @param {any} isFileUpload is file upload
   * @returns {any} promise
   */
  createCustomDashboard: (data: any = {}, isFileUpload = false): Promise<any> =>
    postRequest(`${config.reportApiUrl}api/super-admin/v2/custom-dashboard`, data, isFileUpload),
  /**
   * Get custom dashboard list
   * @param {any} query query
   * @returns {any} promise
   */
  getCustomDashboardList: (query: QueryParameters): Promise<any> =>
    getRequest(`${config.reportApiUrl}api/super-admin/v2/custom-dashboard`, { ...query }),
  /**
   * Delete custom dashboard
   * @param {any} id id
   * @returns {any} promise
   */
  deleteCustomDashboard: (id: string): Promise<any> =>
    deleteRequest(`${config.reportApiUrl}api/super-admin/v2/custom-dashboard/${id}`),
  /**
   * Get custom dashboard details by id
   * @param {any} id id
   * @returns {any} promise
   */
  getCustomDashboardDetails: (id: string): Promise<any> =>
    getRequest(`${config.reportApiUrl}api/super-admin/v2/custom-dashboard/${id}`, {}),
  /**
   * Update custom dashboard
   * @param {any} id id
   * @param {any} data data
   * @param {any} isFileUpload is file upload
   * @returns {any} promise
   */
  updateCustomDashboard: (id: string, data: any = {}, isFileUpload = false): Promise<any> =>
    patchRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/${id}`,
      data,
      isFileUpload,
    ),
  /**
   * Get dashboard facilities status
   * @param {any} query query
   * @returns {any} promise
   */
  getDashboardFacilitiesAccountStatus: (query: QueryParameters): Promise<any> =>
    getRequest(`${config.reportApiUrl}api/super-admin/v2/custom-dashboard/account-stats`, {
      ...query,
    }),
  /**
   * Get top 10 facility accounts by revenue
   * @param {any} query query
   * @returns {any} promise
   */
  getTop10FacilityAccountsByRevenue: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/top-10-facility-accounts-by-revenue`,
      { ...query },
    ),
  /**
   * Get facility accounts growth over time
   * @param {any} query query
   * @returns {any} promise
   */
  getFacilityAccountsGrowthOverTime: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/facility-accounts-growth-over-time`,
      { ...query },
    ),
  /**
   * Get top 10 power consumed enconsumers
   * @param {any} query query
   * @returns {any} promise
   */
  getTop10PowerConsumedEnconsumer: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/top-10-enconsumer-power-consumed`,
      { ...query },
    ),
  /**
   * Get default dashboard filter
   * @returns {any} promise
   */
  getDefalutDashboardFilter: (): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/facilities-hierarchy`,
      {},
    ),
  /**
   * Get station availability status
   * @param {any} query query
   * @returns {any} promise
   */
  getStationAvailabilityStatus: (query: QueryParameters): Promise<any> =>
    getRequest(`${config.reportApiUrl}api/super-admin/v2/custom-dashboard//station-status`, {
      ...query,
    }),

  /**
   * Get utilization rate by station
   * @param {any} query query
   * @returns {any} promise
   */
  getUtilizationRateByStation: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/utilization-rate-by-station`,
      { ...query },
    ),

  /**
   * Get highest revenue generating stations
   * @param {any} query query
   * @returns {any} promise
   */
  getTop10StationsByRevenue: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/top-10-stations-by-revenue`,
      { ...query },
    ),
  /**
   * Get peak usage hours
   * @param {any} query query
   * @returns {any} promise
   */
  getPeakUsageHours: (query: QueryParameters): Promise<any> =>
    getRequest(`${config.reportApiUrl}api/super-admin/v2/custom-dashboard/station-peak-usage`, {
      ...query,
    }),

  /**
   * Get session type distribution
   * @param {any} query query
   * @returns {any} promise
   */
  getGuestVsPaidSessions: (query: QueryParameters): Promise<any> =>
    getRequest(`${config.reportApiUrl}api/super-admin/v2/custom-dashboard/guest-vs-paid-sessions`, {
      ...query,
    }),
  /**
   * Get personal vs commercial sessions
   * @param {any} query query
   * @returns {any} promise
   */
  getPersonalVsCommercialSessions: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/personal-vs-commercial-sessions`,
      { ...query },
    ),
  /**
   * Get successful vs failed transactions
   * @param {any} query query
   * @returns {any} promise
   */
  getSuccessfulVsFailedTransactions: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/successful-vs-failed-transactions`,
      { ...query },
    ),
  /**
   * Get transactions over time
   * @param {any} query query
   * @returns {any} promise
   */
  getTransactionsOverTime: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/transactions-count-over-time`,
      { ...query },
    ),
  /**
   * Get revenue trend
   * @param {any} query query
   * @returns {any} promise
   */
  getRevenueTrend: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/admin-revenue-chart-stats`,
      { ...query },
    ),
  /**
   * Get revenue vs payable vs payout
   * @param {any} query query
   * @returns {any} promise
   */
  getRevenueVsPayableVsPayout: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/revenue-payout-payable-chart-stats`,
      { ...query },
    ),
  /**
   * Get pending vs completed payouts
   * @param {any} query query
   * @returns {any} promise
   */
  getPendingVsCompletedPayouts: (query: QueryParameters): Promise<any> =>
    getRequest(`${config.reportApiUrl}api/super-admin/v2/custom-dashboard/payout-status-stats`, {
      ...query,
    }),
  /**
   * Get payouts over time
   * @param {any} query query
   * @returns {any} promise
   */
  getPayoutsOverTime: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/payout-growth-chart-stats`,
      { ...query },
    ),
  /**
   * Get top 10 facility accounts by payout volume
   * @param {any} query query
   * @returns {any} promise
   */
  getTop10FacilityAccountsByPayoutVolume: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/top-10-facility-accounts-by-payout-volume`,
      { ...query },
    ),
  /**
   * Get total penalties issued over time
   * @param {any} query query
   * @returns {any} promise
   */
  getTotalPenaltiesIssuedOverTime: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/penalty-growth-chart-stats`,
      { ...query },
    ),
  /**
   * Get penalty revenue over time
   * @param {any} query query
   * @returns {any} promise
   */
  getPenaltyRevenueOverTime: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/penalty-revenue-chart-stats`,
      { ...query },
    ),
  /**
   * Get penalties by station
   * @param {any} query query
   * @returns {any} promise
   */
  getPenaltiesByStation: (query: QueryParameters): Promise<any> =>
    getRequest(
      `${config.reportApiUrl}api/super-admin/v2/custom-dashboard/station-penalty-revenue-stats`,
      { ...query },
    ),
};
